import React from "react";
import blockStyles from "@baseStyles/block.scss";
import styles from "./ContentB1.scss";

const ContentB1 = ({title, desc, size, titleSize, descSize, id}) => {

	let sizeClassMap = {
		'XS': blockStyles.sizeXS,
		'S': blockStyles.sizeS,
		'M': blockStyles.sizeM,
		'L': blockStyles.sizeL,
		'XL': blockStyles.sizeXL,
		'800': blockStyles.w800,
		'640': blockStyles.w640
	}

	return (
	  <div
		id={id ? id : undefined}
		className={`${styles.container} ${sizeClassMap[size] ? sizeClassMap[size] : ''}`}>
		  {title &&
			<h2
			  className={`${titleSize ? titleSize : blockStyles.h3} mb-8-12 tcenter`}
			  dangerouslySetInnerHTML={{__html: title}}
			/>
		  }
		  {desc &&
			<div
			  className={`${descSize ? descSize : blockStyles.p} baseMarginBottom tcenter`}
			  dangerouslySetInnerHTML={{__html: desc}}>
			</div>
		  }
	  </div>
	);
}

export default ContentB1;